import React from 'react';
import { Navigate, useOutlet, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStore from '../states/store';
import AppLayout from './AppLayout';
import combineRoutes from '../routes/combine';

export default function ProtectedLayout() {
  const { pathname } = useLocation();
  const auth = useStore((state) => state.auth);
  const outlet = useOutlet();
  const token = useStore((state) => state.token);
  const checkPath = combineRoutes?.auth?.find((row) => row.path === pathname);

  if (!token) {
    return <Navigate to='/' replace />;
  }

  if (checkPath?.permissions?.length > 0 && auth.designation !== 'temp_admin') {
    if (!checkPath?.permissions?.includes(auth.designation)) {
      toast.warning('You have no permission to access this page');

      switch (auth.designation) {
        case 'HTAM':
          return <Navigate to='/dashboard/hcp' replace />;
        case 'SD':
          return <Navigate to='/dashboard/hcp' replace />;
        case 'NSM-HOSPITAL':
          return <Navigate to='/dashboard/hcp' replace />;
        case 'HTAR':
          return <Navigate to='/cwp-approval' replace />;
        case 'DAM':
          return <Navigate to='/report/field-engagement' replace />;
        case 'CNC-MANAGER':
          return <Navigate to='/report/field-engagement' replace />;
        case 'CNC-ANALYST':
          return <Navigate to='/dashboard/client-call-out' replace />;
        case 'CNC-ADMIN':
          return <Navigate to='/dashboard/client-call-out' replace />;
        case 'SFE':
          return <Navigate to='/dcr-listing' replace />;
        default:
          return <Navigate to='/dashboard/crm' replace />;
      }
    }
  }

  if (auth.designation === 'temp_admin' && auth.temp_location !== pathname) {
    window.location.href = auth.temp_location;
  }

  return <AppLayout>{outlet}</AppLayout>;
}
